import { render, staticRenderFns } from "./AgendaDocuments.vue?vue&type=template&id=34d7a08f&"
import script from "./AgendaDocuments.vue?vue&type=script&lang=js&"
export * from "./AgendaDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports